import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ShopeeOpenServiceV2 } from 'src/app/shared/services';
import { shopeeStoreProviders } from 'src/app/shared/config/store-config';
import { ShopeeOrdersComponent } from '../../../shared/components/shopee-orders/shopee-orders.component';

@Component({
    selector: 'app-quick-orders',
    templateUrl: './shopee-general4-order-page.component.html',
    styleUrls: ['./shopee-general4-order-page.component.scss'],
    providers: [
        ...shopeeStoreProviders('shopee-general4'),
        ShopeeOpenServiceV2,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ShopeeOrdersComponent],
})
export class ShopeeGen4OrderPageComponent {
    constructor() {}
}
